<!-- 搜索汽配件 -->
<template>
    <div class="searchAp-ctn" id="selectSaleOrder">
        <div class="search-ctn">
            <div class="search-ctn-left">
                <div class="flex">
                    <div class="search-name">客户</div>
                    <div>
                        <el-input
                            class="search-item"
                            size="small"
                            v-model.trim="searchData.Keyword"
                            v-filter-special-char="searchData.Keyword"
                            placeholder="名称或手机号"
                        ></el-input>
                    </div>
                    <div class="search-name">销售单号</div>
                    <el-input v-model="searchData.OrderCode" class="search-item" size="small" style="width: 200px"></el-input>
                    <div class="search-name">业务员</div>
                    <div>
                        <el-select
                            v-model="searchData.SId"
                            filterable
                            clearable
                            remote
                            size="small"
                            placeholder="选择业务员"
                            @visible-change="siVisibleChange($event)"
                            style="width: 100%"
                        >
                            <el-option v-for="item in SIdList" :key="item.EmployeeId" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                        </el-select>
                    </div>
                    <div class="search-name">创建时间</div>
                    <i class="el-icon-date search-name time-btn" @click="timeVisible = true"></i>
                    <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                    <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
                    <el-button size="small" class="search-btn btn-primary" @click="chooseOrder()">确定</el-button>
                </div>
            </div>
        </div>
        <div class="table-ctn">
            <el-table
                v-loading="loading"
                :header-cell-style="selectionStyle"
                :data="tableData"
                border
                ref="multipleTable"
                @selection-change="handleSelectionChange"
                style="width: 100%; margin-bottom: 10px"
            >
                <el-table-column type="selection" :selectable="selectInit"></el-table-column>
                <el-table-column show-overflow-tooltip width="200" prop="OrderCode" label="销售单号"></el-table-column>
                <el-table-column show-overflow-tooltip min-width="200" prop="EntpCusName" label="客户"></el-table-column>
                <el-table-column show-overflow-tooltip width="150" prop="CallNum" label="电话号码"></el-table-column>
                <el-table-column show-overflow-tooltip min-width="100" prop="OutWarehouseStateName" label="物流状态">
                    <template slot-scope="scope">
                        {{ scope.row.IsDelivery ? '已出仓' : scope.row.IsPartialOutWarehouse ? '部分出仓' : '未出仓' }}
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip min-width="100" prop="PackingState" label="装箱状态">
                    <template slot-scope="scope">
                        {{ scope.row.PackingState ? '未完成装箱' : '已完成装箱' }}
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip width="100" prop="SName" label="业务员"></el-table-column>
                <el-table-column show-overflow-tooltip min-width="120" prop="CreateTime" label="创建时间"></el-table-column>
            </el-table>
        </div>
        <div class="dialog-pagination-ctn">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="searchData.page"
                :page-sizes="[10, 20, 30, 40, 50]"
                :page-size="searchData.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tableDataLength"
            ></el-pagination>
        </div>
        <el-dialog :close-on-click-modal="false" title="创建时间" :visible.sync="timeVisible" :append-to-body="true" width="800px">
            <div class="dialog-content" v-if="timeVisible">
                <timePicker @timerSearch="timerSearch" :start="this.searchData.StartDate" :end="this.searchData.EndDate"></timePicker>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import timePicker from '@/components/common/timePicker';
export default {
    name: '',
    props: [],
    components: { timePicker },
    data() {
        return {
            multipleSelection: null,
            timeVisible: false,
            loading: false,
            cusId: [],
            searchData: {
                Keyword: '',
                OrderCode: '',
                SId: '',
                StartDate: '',
                EndDate: '',
                page: 1,
                limit: 10
            },
            tableData: [],
            customerList: [],
            SIdList: [],
            idList: [],
            tableDataLength: 0
        };
    },
    mounted() {
        this.searchData.EndDate = new Date();
        let start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        this.searchData.StartDate = start;
        this.getTableData();
        let dialogbody = document.querySelector('#selectSaleOrder');
        this.$util.setEventForDialog(this, dialogbody);
    },
    methods: {
        selectionStyle(obj) {
            if (obj.columnIndex == 0) obj.column.renderHeader = null;
            return 'background: #f2f6fc;';
        },
        timerSearch(timer) {
            this.timeVisible = false;
            this.searchData.StartDate = timer.start;
            this.searchData.EndDate = timer.end;
            this.handleSearch();
        },
        // 选择配件
        chooseOrder() {
            //这里还要进行判断
            //1.判断不能为空
            //2.判断企业必须同一个
            //3.判断地址必须同一个
            if (this.idList && this.idList.length > 0) {
                this.$confirm('重新选择销售单进行装箱会清空当前数据，是否确定选择？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: true
                })
                    .then(() => {
                        this.$emit('closeDialog', this.idList);
                    })
                    .catch(() => {});
            } else this.$util.warningMsg('请选择需要装箱的销售 ^_^');
        },
        resetSearch() {
            this.searchData = {
                Keyword: '',
                OrderCode: '',
                SId: '',
                page: 1,
                limit: 10
            };
        },
        getTableData() {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpPackingList/GetEnterprisePackingSaleOrderList',
                    data: this.searchData
                })
                .then(res => {
                    this.loading = false;
                    let data = res.data;
                    if (!data) data = [];
                    this.tableData = data;
                    this.tableDataLength = res.count;
                });
        },
        getSIdList() {
            this.$util.getPurchaserList().then(data => {
                this.SIdList = data;
            });
        },
        selectInit(row, index) {
            //如果没有选中，要开放全部选择
            if (this.multipleSelection && this.multipleSelection.length > 0) {
                if (row.EntpCusId == this.cusId[0]) {
                    return true;
                } else {
                    return false;
                }
            } else return true; //可勾选
        },
        //当业务员下拉框出现时触发
        siVisibleChange(event) {
            let that = this;
            if (event) {
                that.getSIdList();
            }
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
            let idList = [];
            let cusId = [];
            for (let i = 0; i < val.length; i++) {
                idList.push(val[i].EntpCusOId);
                cusId.push(val[i].EntpCusId);
            }
            this.idList = idList;
            this.cusId = cusId;
        }
    }
};
</script>
<style lang="less" scoped>
.option-content {
    display: flex;
    line-height: 30px;
}
.searchAp-ctn {
    overflow-y: auto;
    padding-top: 5px;
}
</style>
